<template>
  <BaseTemplate :currentUser="currentUser">
    <Title class="_title" eng="SHIPPED" :jpn="t('引換所')" />
      <div class="buy-product-history-detail">
        <ExchangeSearchArea
          @clickSearch="clickSearch"
        />
        <ExchangeCardList
          class="card-list"
          :cardListTitle="t('引換カード')"
          :cardList="returnExchangeCardList"
          @handleSquareBtnClick="openConfirm"
        >
          <template>
            <div class="pack_menu_list">
              <div class="pack_menu" :class="{ active: serachParams.type == 3 }" @click="selectPackType(3)">ヴァイス</div>
              <div class="pack_menu" :class="{ active: isGacha }" @click="selectCoinGacha(2)">コインガチャ</div>
            </div>
            <div class="_pack_list" v-if="isGacha">
              <div class="product-list">
                <ProductBanner v-for="(packItem) in packList ? packList.list : []" :key="packItem.id" class="banner"
                  :packItem="packItem" :currentUser="currentUser" @handleBannerClick="goToProductDetail"
                  @handleLoginClick="goToLogin" />
              </div>
            </div>
          </template>
        </ExchangeCardList>
        <div
          v-if="!(returnExchangeCardList.length > 0) && !isGacha"
          class="no-history"
        >
          <span>{{t('引換カードがありません。')}}</span>
        </div>
        <BoxPager
          v-if="exchangeCardList &&
            exchangeCardList.page.pages.length > 0
          "
          class="box-pager"
          :totalPageCount="exchangeCardList.page.all_page"
          :currentPageCount="exchangeCardList.page.page"
          :dispBoxCount="exchangeCardList.page.pages.length"
          :pages="exchangeCardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
    <CommonOverlay class="overlay" v-show="isOpenComp">
      <CommonModal class="modal">
        <div class="modal-title">
          <span>カードを引換しました。</span>
        </div>
        <div class="card-container text">
          <img
            class="card"
            :src="selectCard.image" :alt="selectCard.card_name"
          >
          <div class="card-info">
            <div class="name">
              <span class="card-text">{{selectCard.name}}</span>
            </div>
            <div class="model-number">
              <span class="card-text">{{selectCard.model_number}}</span>
            </div>
            <div class="rarity">
              <span class="card-text">{{selectCard.rarity}}</span>
            </div>
          </div>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="OK"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isOpenModal">
      <CommonModal class="modal">
        <div class="modal-title">
          <span>{{ errorTitle }}</span>
        </div>
        <div class="text">
          <span>{{ errorMessageCount }}</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="OK"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <div class="modal-title">
          <!-- <span>{{currentPack.name}}</span> -->
        </div>
        <div class="modal-subtitle">
          <span>使用コイン</span>
        </div>
        <div class="modal-point">
          <!-- <span class="point-area">{{currentPack.point * count | comma}}</span> -->
        </div>
        <div class="modal-label">保有コイン</div>
        <div class="use-point">
          <div class="point-area">{{ currentUser.coin | comma }}</div>
          <div>→</div>
          <div class="point-area">{{ (currentUser.coin - (selectCard.sub_coin * selectCard.change_num)) | comma }}</div>
        </div>
        <div>
          <span class="explanation">発送は3日～14日以内に発送させていただくようにいたします</span>
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="いいえ"
            :isSub="true"
            @handleSquareBtnClick="closeModal"
          />
          <BlackGradationButton
            class="square-button"
            text="引換を確定"
            @handleSquareBtnClick="buyExchange"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ExchangeCardList from '@/components/organisms/ExchangeCardList.vue';
import ExchangeSearchArea from '@/components/organisms/ExchangeSearchArea.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';
import BoxPager from '@/components/organisms/BoxPager.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import {
  separateDecimalNumber,
} from '@/common/util/format';
import ProductBanner from '@/components/molecules/ProductBanner.vue';

export default {
  name: 'ExchangeCard',
  mixins: [t],

  components: {
    BaseTemplate,
    ExchangeCardList,
    Title,
    BoxPager,
    CommonOverlay,
    CommonModal,
    SquareButton,
    BlackGradationButton,
    ExchangeSearchArea,
    ProductBanner,
  },

  data: () => ({
    isOpenConfirm: false,
    isOpenModal: false,
    isOpenComp: false,
    errorMessageCount: null,
    errorTitle: '',
    selectCard: {},
    pageSize: 1,
    serachParams: {
      type: 3,
      searchText: '',
      sort: 0,
    },
    isGacha: false,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      exchangeCardList: 'exchangeCard/exchangeCardList',
      exchangeCheckResult: 'exchangeCard/exchangeCheckResult',
      exchangeResult: 'exchangeCard/exchangeResult',
      packList: 'pack/packList',
    }),
    returnExchangeCardList() {
      if (!this.exchangeCardList) {
        return [];
      }
      return this.exchangeCardList.list;
    },
  },

  filters: {
    comma(value) {
      return separateDecimalNumber(value);
    },
  },

  watch: {
    exchangeCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          this.$store.dispatch('exchangeCard/clearExchangeCheckResult');
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          if (newVal.result === '-3') {
            this.errorTitle = '交換上限を超えています';
          } else {
            this.errorTitle = 'コイン不足';
          }
          this.isOpenModal = true;
        }
      }
    },
  },

  created() {
    const pageNumber = 1;
    this.pageSize = pageNumber;
    const postParams = this.serachParams;
    this.$store.dispatch('exchangeCard/setExchangeCardList', { postParams, pageNumber });
  },

  methods: {
    changeCurrentPageCount(pageNumber) {
      const postParams = this.serachParams;
      this.pageSize = pageNumber;
      this.$store.dispatch('exchangeCard/setExchangeCardList', { postParams, pageNumber });
    },
    closeModal() {
      this.isOpenModal = false;
      this.isOpenConfirm = false;
      this.isOpenComp = false;
    },
    buyExchange() {
      (async () => {
        this.isOpenConfirm = false;
        const postParams = {
          card_id: this.selectCard.id,
          change_num: this.selectCard.change_num,
        };
        await this.$store.dispatch('exchangeCard/exchange', { postParams });
        const { exchangeResult } = this;
        const isSuceess = exchangeResult.state === 200 && exchangeResult.result === '1';
        if (isSuceess) {
          await this.$store.dispatch('exchangeCard/clearExchangeResult');
          await this.$store.dispatch('user/setCurrentUser');
          this.isOpenComp = true;
          this.changeCurrentPageCount(this.pageSize);
        } else {
          const { count } = exchangeResult.errors;
          window.alert(count);
        }
      })();
    },
    async openConfirm(card) {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/login' });
        return;
      }
      await this.$store.dispatch('user/setCurrentUser');
      this.selectCard = card;
      const postParams = {
        card_id: card.id,
        change_num: card.change_num,
      };
      this.$store.dispatch('exchangeCard/setExchangeCheckResult', { postParams });
    },
    clickSearch(serachParams) {
      this.serachParams = serachParams;
      const pageNumber = 1;
      const postParams = this.serachParams;
      this.$store.dispatch('exchangeCard/setExchangeCardList', { postParams, pageNumber });
      this.isGacha = false;
    },
    selectPackType(type) {
      this.isGacha = false;
      this.serachParams.type = type;
      const pageNumber = 1;
      const postParams = this.serachParams;
      this.$store.dispatch('exchangeCard/setExchangeCardList', { postParams, pageNumber });
    },
    selectCoinGacha(type) {
      this.serachParams.type = 0;
      this.isGacha = true;
      this.$store.dispatch('exchangeCard/clearExchangeCardList');
      const postParams = {
        payment_method: type,
      };
      this.$store.dispatch('pack/setPostPackList', { postParams });
    },
    goToLogin() {
      this.$router.push({ path: '/login' });
    },
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
  },
};
</script>

<style lang="scss" scoped>
$pagerWidth: 100%;
._title {
  margin-top: 20px;
}
.buy-product-history-detail{
  width: 100%;
  min-height: 100%;
  padding: 20px 0px;
  text-align: center;
  .buy-product-history-detail-title{
    padding: 0px 20px;
    .text{
      height: 59px;
      font-size: 20px;
      line-height: 30px;
      font-weight: 700;
      color: $black;
    }
  }
  .flex-box {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    color: $black;
    .buy-date {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      margin-right: 20px;

      .text {
        font-family: $notoSans;
        font-size: 14px;

        &.date {
          margin-left: 10px;
          font-weight: 700;
        }
      }
    }

    .delivery-code {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      margin-left: 20px;

      .text {
        font-family: $notoSans;
        font-size: 14px;

        &.date {
          margin-left: 10px;
          font-weight: 700;
        }
      }
    }
  }
  .card-list{
    margin-top: 20px;
    &.return-point{
      margin-top: 11px;
    }
  }
  .shadow-box{
    width: 255px;
    height: 40px;
    margin: 14px auto 0px;
    .text{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0px;
      padding: 0 36px;
      font-family: $notoSans;
      font-size: 14px;
      line-height: 23.4px;
      color: $deepGray;
      .point{
        margin-left: auto;
        font-family: $notoSerif;
        font-size: 24px;
        font-weight: 700;
        line-height: 1.5;
        color: $deepGray;
      }
      .unit{
        margin-left: 10px;
      }
    }
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .square-button{
      width: 200px;
      height: 40px;
    }
  }
  .border-area {
    margin: 30px 10px 0;
  }
  .pack_menu_list {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $mainColor;
    height: 70px;
    margin: 0 0 20px 0;
    overflow-x: auto;

    .pack_menu {
      color: $white;
      width: 130px;
      min-width: 130px;
      height: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: .4s;

      &:hover {
        background-color: #fff;
        color: $mainColor;
      }

      &.active {
        background-color: #fff;
        color: $mainColor;
      }
    }
  }
}
.point_text {
  display: flex;
  padding: 10px 30px;
  justify-content: space-between;
  align-items: center;
  .point {
    color: $black;
    font-size: 24px;
    &:before {
      content: "P";
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      background-color: $mainColor;
      color: $white;
      font-size: 24px;
      border-radius: 100px;
      margin-right: 5px;
      font-weight: bold;
    }
  }
  .box-pager{
    width: $pagerWidth;
    height: 30px;
    margin: 0px auto;
  }
}
.overlay{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
  .modal{
    padding: 40px 28px;
    font-family: $notoSans;
    color: $black;
    text-align: center;
    width: auto;
    .modal-title{
      font-size: 20px;
      font-weight: 700;
    }
    .text{
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }
    .modal-button-area{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      .square-button{
        width: 120px;
        height: 50px;
        & + .square-button{
          margin-left: 20px;
        }
      }
    }
    .card-container{
      display: flex;
      flex-direction: column;
      width: 100px;
      min-width: 100px;
      margin: 20px auto 0px;
      .card{
        width: 100%;
        height: 146px;
      }
      .card-info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        width: 100%;
        .name, .model-number{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          padding: 2px 2px;
          .card-text{
            display: inline-block;
            font-family: $notoSans;
            font-size: 12px;
            color: $black;
            line-height: 1.25;
            white-space: pre-wrap;
          }
        }
        .num {
          .card-text {
            color: $black;
          }
        }
        .rarity {
          padding: 0px 10px 4px 10px;
          border-radius: 5px;
          border: solid 1px $mainColor;
          background-color: $mainColor;
          span {
            white-space: pre-wrap;
            display: inline;
            font-size: 12px;
            color: $white;
          }
        }
      }
    }
  }
}
.pack-confirm {
  .modal-title {
    color: $mainColor;
    margin-bottom: 10px;
  }
  .modal-subtitle {
    font-weight: bold;
  }
  .point-area {
    position: relative;
    &:before {
      content: "C";
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      background-color: #fff6bd;
      border: solid 1px #d99e2c;
      color: #d79a25;
      font-weight: bold;
    }
  }
  .modal-label {
    text-align: left;
    font-size: 14px;
  }
  .modal-point {
    font-size: 32px;
    font-weight: bold;
    margin: 10px 0 10px 50px;
    .point-area {
      &:before {
        left: -50px;
        top: 5px;
      }
    }
  }
  .use-point {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 10px;
    .point-area {
      margin: 10px 0 10px 30px;
      &:before {
        left: -30px;
        top: 1px;
        height: 25px;
        width: 25px;
        font-size: 14px;
      }
    }
  }
  .buy-pack-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    padding-top: 10px;
    border-top: solid 2px $black;
    span {
      &:last-child {
        font-size: 32px;
        &:after {
          content: "パック";
          font-size: 14px;
        }
      }
    }
  }
  .explanation {
    font-size: 12px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .buy-product-history-detail{
    padding: 0 0 20px 0;
    .pack_menu_list {
      height: auto;
      justify-content: center;
      flex-wrap: wrap;
      .pack_menu {
        height: 40px;
        font-size: 14px;
        width: 80px;
        min-width: 80px;
        &:hover {
          background-color: auto;
        }
      }
    }
  }
  .point_text {
    .point {
      font-size: 18px;
      &:before {
        width: 24px;
        height: 24px;
        font-size: 20px;
      }
    }
  }
  .overlay {
    .modal {
      width: 90%;
      .modal-button-area {
        flex-direction: column-reverse;
        .square-button {
          & + .square-button{
            margin-left: 0px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .banner_base {
    margin: 0 2px 5px 2px;
    width: 48.6%;
    min-width: 30vw;
  }
}
.banner {
    margin-bottom: 20px;
  }
._pack_list {
  margin: 0 auto 50px auto;
  max-width: 1220px;
  .post_list {
    margin-top: 10px;
    .images {
      width: 100%;
      display: flex;
      .image {
        width: 25%;
        padding: 5px;
        img {
          width: 100%;
        }
      }
    }
  }
}
.product-list {
  display: flex;
  padding-bottom: 10px;
  flex-wrap: wrap;
}
</style>
